// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject, Subject } from 'rxjs';

// --- HS Code
import { SettingsModel, UserProfileModel, UserDetailsModel, EmailAddressValidationModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class ProfileBaseService {
  protected _isLoaded: boolean;

  protected _settings$: BehaviorSubject<SettingsModel>;
  get settings$(): Observable<SettingsModel> {
    return this._settings$;
  }

  protected _userDetails$: BehaviorSubject<UserDetailsModel>;
  get userDetails$(): Observable<UserDetailsModel> {
    return this._userDetails$;
  }

  protected _updateUserDetailsError$: BehaviorSubject<string>;
  get updateUserDetailsError$(): Observable<string> {
    return this._updateUserDetailsError$;
  }

  protected _updateUserDetailsResult$: Subject<boolean>;
  get updateUserDetailsResult$(): Observable<boolean> {
    return this._updateUserDetailsResult$;
  }

  protected _updateLoginDetailsError$: BehaviorSubject<string>;
  get updateLoginDetailsError$(): Observable<string> {
    return this._updateLoginDetailsError$;
  }

  protected _updateLoginDetailsResult$: Subject<boolean>;
  get updateLoginDetailsResult$(): Observable<boolean> {
    return this._updateLoginDetailsResult$;
  }

  protected _isEmailAddressInUse$: BehaviorSubject<EmailAddressValidationModel>;
  get isEmailAddressInUse$(): Observable<EmailAddressValidationModel> {
    return this._isEmailAddressInUse$;
  }

  protected _isValidatingEmailAddress$: BehaviorSubject<boolean>;
  get isValidatingEmailAddress$(): Observable<boolean> {
    return this._isValidatingEmailAddress$;
  }

  protected _isUpdating$: BehaviorSubject<boolean>;
  get isUpdating$(): Observable<boolean> {
    return this._isUpdating$;
  }

  constructor() {
    this._settings$ = new BehaviorSubject<SettingsModel>(null);
    this._userDetails$ = new BehaviorSubject<UserDetailsModel>(null);
    this._updateUserDetailsError$ = new BehaviorSubject<string>(null);
    this._updateUserDetailsResult$ = new Subject<boolean>();
    this._updateLoginDetailsError$ = new BehaviorSubject<string>(null);
    this._updateLoginDetailsResult$ = new Subject<boolean>();
    this._isEmailAddressInUse$ = new BehaviorSubject<EmailAddressValidationModel>(null);
    this._isValidatingEmailAddress$ = new BehaviorSubject<boolean>(null);
    this._isUpdating$ = new BehaviorSubject<boolean>(null);
  }

  abstract loadProfile(): void;
  abstract update(userDetails: UserProfileModel): Observable<boolean>;
  abstract updateUserDetails(userDetails: UserDetailsModel);
  abstract updateLoginDetails(loginDetails: UserDetailsModel);
  abstract checkIfEmailAddressInUse(emailAddress: string);
}
